<template>
  <div>
    <label>{{ title }}</label>
    <div class="row form-group2">
      <el-select
        :value="value"
        class="col-md-12 select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <el-option
          v-for="option in selects.profileCategories"
          :value="option.value"
          :label="option.label"
          :key="option.value"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectProfileCategory',
  props: ['value', 'title'],
  data() {
    return {
      selects: {
        simple: '',
        profileCategories: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
    this.selects.simple = this.value;
  },
  methods: {
    fetchData() {
      return this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/profiles/categories`,
        )
        .then(response => {
          this.selects.profileCategories = response.data.map(entity => ({
            value: entity,
            label: entity,
          }));
        });
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
</style>
